import { TApiSet } from "../../api/endpoints/Set";
import { Nullable } from "../../../types/utils";
import { TApiSubset } from "../../api/endpoints/Subset";
import { SelectionState, TParameterSelection } from "../../components/EuCutOutConfigurator";
import { OrderCategory, TApiOrderDetails } from "../../api/endpoints/Order";
import { TApiParameter } from "../../api/endpoints/Parameter";
import { TOrderProduct } from "../../api/endpoints/OrderProduct";

const parameterSelectionKey = (selection: TParameterSelection): string => {
  return [selection.parameter.shortname, selection.subset.id].join('::');
}

const deriveSetAndSubsetFromSetsCollection = (sets: Array<TApiSet>, subsetId: number): Nullable<{ set: TApiSet, subset: TApiSubset }> => {
  let result: Nullable<{ set: TApiSet, subset: TApiSubset }> = null;

  sets.forEach(set => {
    const subset = set.subsets.find(subset => subset.id === subsetId);

    if (subset) {
      result = {
        set,
        subset
      }
    }
  });

  return result;
}

const deriveParameterSelection = (
  product: Nullable<TOrderProduct<OrderCategory.EU_CUTOUT>>,
  sets: Array<TApiSet>,
  params: Record<string, TApiParameter>
) => {

  if (!product) {
    return {};
  }

  const selection = product.data.param.reduce((acc, product) => {
    const { value: shortname, subset_id } = product;
    const indexKey = [shortname, subset_id].join('::');

    acc[indexKey] = {
      parameter: params[shortname],
      ...deriveSetAndSubsetFromSetsCollection(sets, subset_id)!
    };

    return acc;
  }, {} as SelectionState);

  return selection;
}

const EuCutOutProductHelpers = {
  deriveParameterSelection,
  parameterSelectionKey
}

export default EuCutOutProductHelpers;
